/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const GET_DISPLAY_COOLER_PRODUCT_STATS = gql`
  query GetDisplayCoolerProductStats(
    $displayId: ID!
    $startDate: DateTime!
    $endDate: DateTime!
    $pagination: OffsetLimitPaginationFilter
    $ordering: DisplayCoolerProductStatsOrdering
  ) {
    displayCoolerProductStats(
      displayId: $displayId
      startDate: $startDate
      endDate: $endDate
      pagination: $pagination
      ordering: $ordering
    ) {
      totalCount
      results {
        upc
        name
        revenue
        revenueTrend
        margin
        volume
        facings
        revenuePerFacing
        averageVolumePerDay
        daysSupply
      }
    }
  }
`
